import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function useAutoLogout() {
  const [expired, setExpired] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Intercept all axios responses globally
    const responseInterceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (
          error.response &&
          (error.response.status === 401 ||
            error.response.data?.message?.includes("Token no longer valid"))
        ) {
          localStorage.removeItem("token");
          setExpired(true);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  const handleLoginRedirect = () => {
    setExpired(false);
    navigate("/login");
  };

  return { expired, handleLoginRedirect };
}
